import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function AssignSessionToCenter() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [clearRows, setClearRows] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      centerId: "",
    },
  });

  const [classesData, setClassesData] = useState([]);
  const [selectedSessionIds, setSelectedSessionIds] = useState(
    savedCenterId || null
  );
  const [selectedCenterIds, setSelectedCenterIds] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [centerData, setCenterData] = useState([]);
  const [classSelectError, setClassSelectError] = useState("");

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Session/GetSessions?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSessionData(response.sessions);
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
  }, [setValue, triggerRerender, savedCenterId]);

  const getAllCenterList = async (sessionId) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Session/AssignedCenterToSession?sessionId=${sessionId}&organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCenterData(response);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.sessionCenterId,
      sortable: true,
      omit: true,
    },
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.centerName,
      sortable: true,
    },
  ];

  // const onCenterSelect = (centerIds) => {
  //   const valuesArray = centerIds.map((center) => ({
  //     id: center.value,
  //   }));
  //   setSelectedCenterIds(valuesArray);
  // };

  const onCenterSelect = (selectedCenter) => {
    setSelectedSessionIds(selectedCenter.value);
  };

  const handleRowSelected = (state) => {
    const selectedRows = state.selectedRows.map((row) => ({
      id: row.centerId,
      status: true,
    }));

    const unselectedRows = centerData
      .filter(
        (row) =>
          !state.selectedRows.some(
            (selected) => selected.sessionCenterId === row.sessionCenterId
          )
      )
      .map((row) => ({
        id: row.centerId,
        status: false,
      }));
    // Combine selected and unselected rows
    setSelectedCenterIds([...selectedRows, ...unselectedRows]);
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    if (selectedCenterIds.length === 0) {
      setClassSelectError("Please select at least one class.");
      return;
    } else {
      setClassSelectError("");
    }

    const formData = {
      createdBy: localStorage.getItem("userId"),
      sessionId: selectedSessionIds,
      centerIds: selectedCenterIds,
    };

    try {
      const response = await post("Session/SaveCenterSession", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.isSuccess) {
        toast.success("Success!");
        getAllCenterList(selectedSessionIds);
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assign Session to Center</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">
                    Session<span className="text-danger fs-9">*</span>
                  </label>

                  {/* <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={!!savedCenterId}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`centerId`, null);
                          } else {
                            setValue(
                              `centerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            onCenterSelect(selectedOption);
                            getAllClassesList(selectedOption.value);
                          }
                          trigger(`centerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable={!savedCenterId}
                        // isMulti
                      />
                    )}
                  /> */}

                  <Controller
                    name="sessionId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={sessionData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        // isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`sessionId`, null);
                          } else {
                            setValue(
                              `sessionId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            onCenterSelect(selectedOption);
                            getAllCenterList(selectedOption.value);
                          }
                          trigger(`sessionId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />

                  {errors.sessionId && (
                    <small className="text-danger">
                      {errors.sessionId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label">
                    Centers<span className="text-danger fs-9">*</span>
                  </label>

                  <small className="text-danger">{classSelectError}</small>

                  <DataTable
                    columns={columns}
                    data={centerData}
                    pagination
                    dense
                    customStyles={customTableStyles}
                    // highlightOnHover={true}
                    // pointerOnHover={true}
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={clearRows}
                    onChangePage={setCurrentPage}
                    onChangeRowsPerPage={setRowsPerPage}
                    selectableRowSelected={useMemo(
                      () => (row) => row.status === true, // Automatically check rows with status 1
                      [classesData]
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default AssignSessionToCenter;
